<template>
  <div>
    <div v-show="txbiaod == 1">
      <!-- 骨架屏 -->
      <skeleton-screen v-show="!dataLoaded"></skeleton-screen>
      <div v-if="dataLoaded" class="col-md-12 col-sm-12 col-lg-12 col-xl-12 d-flex pl-0 pr-0 ml-0 justify-content-between sjtop phoneClass">
        <div class="col-sm-12 parent pl-0 pr-0 scroll-container" ref="scrollContainer">

          <!-- 上半部分-新 -->
          <div class="col-sm-12 baise yuanjiao pl-0 pr-0" style="overflow: hidden;" id="zhixingld">
            <!-- 轮播图-新 -->
            <div class="position-realctive">
              <b-carousel id="carousel-fade" v-if="info.banner.length > 0" style="text-shadow: 0px 0px 2px #000;height: 300px;border-radius: 12px 12px 0 0;" fade img-width="1024" img-height="100" class="imase  sjbgaodu ">
                <b-carousel-slide v-for="(item, index) in info.banner" :key="index" caption="" :img-src="item"></b-carousel-slide>
              </b-carousel>
              <div class="banana-box pt-4" v-if="info.need_volunteer == 1 || info.is_training == 2">
                <div :class="screenWidth <= 1200?'':'mt-3'" class=" pt-2 pl-4  d-flex">
                  <div class="event-tag tag-volunteer mr-2" v-if="info.need_volunteer == 1">{{$t("需要志工")}}</div>
                  <div class="event-tag tag-training" v-if="info.is_training == 2" >{{$t("需要培训")}}</div>
                </div>
                <div class="mt-2 pl-4 " style="font-size:calc(14px + 0.4vw);color:white;font-weight: 700;">{{info.name}}</div>
                <div class="mt-2 pl-4  d-flex yinc" style="font-size:calc(12px + 0.4vw)">
                  <div class="event-meta-item mr-2">📅 {{timeFilter(info.start_time)}} - {{timeFilter(info.end_time)}}</div>
                  <div class="event-meta-item mr-2">📍 {{info.address}}</div>
                  <div class="event-meta-item mr-2">👥 {{info.organization_name}}</div>
                </div>
                <button v-if="info.is_member == 0" @click="chanyughd(id, info.name,info)" class="mt-3 ml-4 pl-3 pr-3 pt-2 pb-2 yuanjiao25 curpo ckqbb  yellowBtn" :style="{'font-size': screenWidth <= 1200 ? 'calc(10px + 0.4vw)' : 'calc(8px + 0.4vw)','background': '#FFD672' , 'border': 'none', 'color': '#000'}">
                  {{ $t("加入活动") }}
                </button>
              </div>
            </div>
          </div>
          <!-- 贴文等方块 -->
          <div class="col-sm-12 pl-1 pr-1 mt-4  justify-content-between" :class="screenWidth <= 1200?' ':'d-flex'" style="margin-left:-0.25rem">
            <div class="pt-4 pb-4   align-items-center justify-content-center d-flex" :class="screenWidth <= 1200?'stat-card-small mb-2 m-1':'stat-card'" style="align-items: center;background-color: #fcd7d5;">
              <div style="font-size:calc(12px + 0.4vw);font-weight: 500;">{{$t("贴文")}}：</div>
              <div style="font-size:calc(12px + 0.4vw); font-weight: 500;">{{ info.moment_num ? info.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
            </div>
            <div class="pt-4 pb-4   align-items-center justify-content-center d-flex " :class="screenWidth <= 1200?'stat-card-small mb-2 m-1':'stat-card'" style="align-items: center;background-color: rgb(253, 221, 201);">
              <div style="font-size:calc(12px + 0.4vw);font-weight: 500;">{{$t("参与人数")}}：</div>
              <div style="font-size:calc(12px + 0.4vw); font-weight: 500;">{{ info.member_num ? info.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
            </div>
            <div class="pt-4 pb-4   align-items-center justify-content-center d-flex " :class="screenWidth <= 1200?'stat-card-small mb-2 m-1':'stat-card'" style="align-items: center;background-color: rgb(255, 235, 210);">
              <div style="font-size:calc(12px + 0.4vw);font-weight: 500;">{{$t("活动评分")}}：</div>
              <div style="font-size:calc(12px + 0.4vw); font-weight: 500;">{{ info.rating }}</div>
            </div>
          </div>

          <!-- 导航栏 -->
          <div class="col-sm-12 nav-box mt-4" style="border-bottom: 1px solid #eee;" :class="screenWidth <= 1200?'overflowAuto':'d-flex align-items-center'">
            <div class="pl-4 pr-4 pb-3 pt-2 curpo" style="border-bottom: 2px solid transparent; display: inline-block;" :class="item.id == wauto ?'yellow-color':''" @click="wautobutt(item.id)" v-for="(item, index) in visibleItems" :key="index">{{ item.text }}</div>
          </div>


          <!-- 上半部分-旧 -->
          <div class="col-sm-12 baise yuanjiao pl-0 pr-0" style="overflow: hidden;" id="zhixingld" v-if="false">
            <!-- 轮播图-旧 -->
            <b-carousel id="carousel-fade" v-if="info.banner.length > 0" style="text-shadow: 0px 0px 2px #000;height: 400px;border-radius: 12px 12px 0 0;" fade indicators img-width="1024" img-height="100" class="imase  sjbgaodu yinc">
              <b-carousel-slide v-for="(item, index) in info.banner" :key="index" caption="" :img-src="item"></b-carousel-slide>
            </b-carousel>
            <b-carousel id="carousel-fade" v-if="info.banner.length > 0" style="text-shadow: 0px 0px 2px #000;border-radius: 12px 12px 0 0;object-fit: cover;" fade indicators img-width="1024" img-height="100" class="aaaa">
              <b-carousel-slide v-for="(item, index) in info.banner" :key="index" caption="" :img-src="item"></b-carousel-slide>
            </b-carousel>
            <div class="p-4 sjiduand1">
              <div class="col-sm-12 pl-0 pr-0 d-flex justify-content-between yinc">
                <div class="col-sm-12 col-lg-8 col-xl-9 pl-0 pr-0">
                  <div class="d-flex justify-content-between pl-0 pr-0 col-sm-12 mb-3">
                    <div class="col-sm-8 col-md-8 col-lg-8 col-xl-9 pl-0 pr-0">
                      <div class="mb-3" style="font-size: calc(11px + 0.4vw);font-weight: 700;">{{ info.name }}
                      </div>
                      <span class="mt-2 mb-2 pl-3 pr-3 pt-2 pb-2" style="font-size: calc(6px + 0.4vw);background-color: #FFFAF0;">
                        {{ info.organization_name }}</span>
                    </div>
                    <div class="d-flex col-sm-4  col-md-4 col-lg-4 col-xl-4 pl-0 pr-0">
                      <div class="jhsad col-sm-4 mr-2">
                        <div>
                          <div style="font-size: calc(7px + 0.4vw);font-weight: 700;">
                            {{ info.moment_num ? info.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(6px + 0.4vw);">{{ $t("贴文") }}</div>
                        </div>
                      </div>
                      <div class="jhsad col-sm-4 mr-2" style="background: #FDDDC9">
                        <div>
                          <div style="font-size: calc(7px + 0.4vw);font-weight: 700;">
                            {{ info.member_num ? info.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(6px + 0.4vw);">{{ $t("参与人数") }}</div>
                        </div>
                      </div>
                      <div class="jhsad col-sm-4" style="background: #FFEBD2;">
                        <div>
                          <div style="font-size: calc(7px + 0.4vw);font-weight: 700;">
                            {{ info.rating }}
                          </div>
                          <div style="font-size: calc(6px + 0.4vw);">{{ $t("活动评分") }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="sjbxzt" style="color: #666666;font-size: calc(5px + 0.4vw);" v-html="formattedDescription(info.description)"></div>
                  <div class="mt-3 yinc" v-if="info.business_number||info.tel||info.email">
                    <div class="d-flex align-items-center">
                      <div class="d-flex justify-content-between align-items-center mr-2" v-if="info.business_number">
                        <div class="mr-1"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_tb@2x.png" alt=""></div>
                        <div style="font-size: calc(7px + 0.4vw);color: #666666;">{{ $t("統編") }}：{{ info.business_number ? info.business_number : '--' }}</div>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mr-2" v-if="info.about_tel">
                        <div class="mr-1"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_iphone@2x (1).png" alt=""></div>
                        <div style="font-size: calc(7px + 0.4vw);color: #666666;">{{ $t("電話") }}：{{ info.about_tel }}</div>
                      </div>
                      <div class="d-flex justify-content-between align-items-center mr-2" v-if="info.about_email">
                        <div class="mr-1"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_email@2x (1).png" alt=""></div>
                        <div style="font-size: calc(7px + 0.4vw);color: #666666;">{{ $t("信箱") }}：{{ info.about_email }}</div>
                      </div>
                    </div>
                  </div>

                  <button v-if="info.is_member == 0" @click="chanyughd(id, info.name,info)" class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-4" style="font-size: calc(6px + 0.4vw);background: #FFD672;border: none;color: #000;">
                    {{ $t("加入活动") }}
                  </button>
                  <button v-else class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-4" style="font-size: calc(6px + 0.4vw);background: #E5E5E5;border: none;color: #000;">
                    {{ $t("已报名") }}
                  </button>
                  <button @click="lijitianda()" v-if="info.need_questionnaire==1 && info.is_answer==0" class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-4 ml-3" style="font-size: calc(6px + 0.4vw);background: #FCD7D5;border: none;color: #000;">
                    {{ $t("問卷調查") }}
                  </button>
                </div>
                <div class="col-md-4 col-lg-3 col-xl-2 tpiand pl-0 pr-0">
                  <img style="width: 100%;height: 200px;object-fit: cover;" class="yuanjiao" :src="info.image" alt="" />
                  <div class="d-flex mt-2" style="justify-content: center;" v-if="info.about_facebook||info.about_line">
                    <a class="mr-2 curpo" v-if="info.about_facebook" :href="info.about_facebook"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/grzx/icon_grzx_lj_three@2x.png" alt=""></a>
                    <a class="mr-2 curpo" v-if="info.about_line" :href="info.about_line"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_lj_six@2x.png" alt=""></a>
                    <!-- <div class="curpo" v-if="info.file_ppt" @click="downloadPPT(info.file_ppt,info.file_name)"><img style="width: calc(20px + 0.4vw);height: calc(20px + 0.4vw);" src="@/img/icon_grzx_pdf@2x.png" alt=""></div> -->
                  </div>
                </div>
              </div>

              <div class=" mb-2 aaaa" style="width: 100%;">
                  <div class="d-flex " style="width: 100%;">
                    <div class="aaaa pl-0 pr-0" style="display: block;">
                      <img style="width: 100px;object-fit: cover;" class="yuanjiao" v-if="info.image" :src="info.image" alt="" />
                      <img style="width: 100%;" v-else src="" alt="" />
                    </div>
                    <div class="ml-2" style="width: 100%;">
                      <div class="mb-2 sjtoto" style="font-size: calc(12px + 0.4vw);font-weight: 700;">
                        {{ info.name }}
                      </div>
                      <div class="pl-3 pr-3 pt-2 pb-2 sjbxzt" style="background-color: #FFFAF0;width: auto;display: inline-block;">
                      {{ info.organization_name }}
                      </div>
                    </div>
                  </div>
                </div>
              <div class=" mb-3 aaaa" style="width: 100%;">
                
                <div class="d-flex justify-content-between" style="align-items: center;">
                    
                    <div class="d-flex justify-content-between" style="width: 100%;">
                      <div class="jhsad mr-2" style="width: 33%;">
                        <div>
                          <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                            {{ info.moment_num ? info.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(10px + 0.4vw);">{{ $t("贴文") }}</div>
                        </div>
                      </div>
                      <div class="jhsad mr-2" style="background: #FDDDC9;width: 33%;">
                        <div>
                          <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                            {{ info.member_num ? info.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                          </div>
                          <div style="font-size: calc(10px + 0.4vw);">{{ $t("参与人数") }}</div>
                        </div>
                      </div>
                      <div class="jhsad" style="background: #FFEBD2;width: 33%;">
                        <div>
                          <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                            {{ info.rating }}
                          </div>
                          <div style="font-size: calc(10px + 0.4vw);">{{ $t("活动评分") }}</div>
                        </div>
                      </div>
                    </div>
                  </div>


                <div style="height: 1rem;width: 100%;"></div>
                <div class="sjbxzt" style="color: #666666;font-size: calc(6px + 0.4vw);" v-html="formattedDescription(info.description)"></div>


                <!-- <div class="d-flex justify-content-between" style="align-items: center;">
                  <div class="pl-3 pr-3 pt-2 pb-2 sjbxzt" style="background-color: #FFFAF0;max-width: 37%;">
                    {{ info.organization_name }}
                  </div>
                  <div class="d-flex justify-content-between" style="width: 62%;">
                    <div class="jhsad mr-2" style="width: 33%;">
                      <div>
                        <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                          {{ info.moment_num ? info.moment_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                        </div>
                        <div style="font-size: calc(10px + 0.4vw);">{{ $t("贴文") }}</div>
                      </div>
                    </div>
                    <div class="jhsad mr-2" style="background: #FDDDC9;width: 33%;">
                      <div>
                        <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                          {{ info.member_num ? info.member_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}
                        </div>
                        <div style="font-size: calc(10px + 0.4vw);">{{ $t("参与人数") }}</div>
                      </div>
                    </div>
                    <div class="jhsad" style="background: #FFEBD2;width: 33%;">
                      <div>
                        <div style="font-size: calc(14px + 0.4vw);font-weight: 700;">
                          {{ info.rating }}
                        </div>
                        <div style="font-size: calc(10px + 0.4vw);">{{ $t("活动评分") }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="height: 1rem;width: 100%;"></div>
                <div class="sjbxzt" style="color: #666666;font-size: calc(5px + 0.4vw);">
                  {{ info.description }}
                </div> -->
                <div class="aaaa mt-3" v-if="info.about_facebook||info.about_line||info.business_number||info.about_tel||info.about_email">
                  <div class="d-flex mb-3" v-if="!sfoudhj" style="justify-content: center;">
                    <a class="mr-4 curpo" v-if="info.about_facebook" :href="info.about_facebook"><img style="width: calc(30px + 0.4vw);height: calc(30px + 0.4vw);" src="@/img/grzx/icon_grzx_lj_three@2x.png" alt=""></a>
                    <a class="mr-4 curpo" v-if="info.about_line" :href="info.about_line"><img style="width: calc(30px + 0.4vw);height: calc(30px + 0.4vw);" src="@/img/icon_grzx_lj_six@2x.png" alt=""></a>
                    <!-- <div class="curpo" v-if="info.file_ppt" @click="downloadPPT(info.file_ppt,info.file_name)"><img style="width: calc(30px + 0.4vw);height: calc(30px + 0.4vw);" src="@/img/icon_grzx_pdf@2x.png" alt=""></div> -->
                  </div>
                  <div class="mb-3" v-if="!sfoudhj">
                    <div v-if="info.business_number" class="d-flex justify-content-between align-items-center yuanjiao pt-2 pb-2 pl-3 pr-3 mb-2" style="background: #FFFAF0;">
                      <div class="d-flex align-items-center">
                        <div class="mr-1"><img style="width: calc(25px + 0.4vw);height: calc(25px + 0.4vw);" src="@/img/icon_grzx_tb@2x.png" alt=""></div>
                        <div class="sjbxzt">{{ $t("統編") }}：</div>
                      </div>
                      <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);">{{ info.business_number ? info.business_number : '--' }}</div>
                    </div>
                    <div v-if="info.about_tel" class="d-flex justify-content-between align-items-center yuanjiao pt-2 pb-2 pl-3 pr-3 mb-2" style="background: #FFFAF0;">
                      <div class="d-flex align-items-center">
                        <div class="mr-1"><img style="width: calc(25px + 0.4vw);height: calc(25px + 0.4vw);" src="@/img/icon_grzx_iphone@2x (1).png" alt=""></div>
                        <div class="sjbxzt">{{ $t("電話") }}：</div>
                      </div>
                      <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);">{{ info.about_tel }}</div>
                    </div>
                    <div v-if="info.about_email" class="d-flex justify-content-between align-items-center yuanjiao pt-2 pb-2 pl-3 pr-3" style="background: #FFFAF0;">
                      <div class="d-flex align-items-center">
                        <div class="mr-1"><img style="width: calc(25px + 0.4vw);height: calc(25px + 0.4vw);" src="@/img/icon_grzx_email@2x (1).png" alt=""></div>
                        <div class="sjbxzt">{{ $t("信箱") }}：</div>
                      </div>
                      <div class="sjbxzt" style="font-size: calc(7px + 0.4vw);">{{ info.about_email }}</div>
                    </div>
                  </div>
                  <div class="d-flex" style="justify-content: center;">
                    <div class="d-flex align-items-center curpo" @click="sfoudhj = !sfoudhj">
                      <div class="sjbxzt mr-2">{{ sfoudhj ? $t("展開更多") : $t("收回更多") }}</div>
                      <div>
                        <img v-if="sfoudhj" style="width: 25px;height: 25px;" src="@/img/icon_zhankai@2x.png" alt="">
                        <img v-else style="width: 25px;height: 25px;" src="@/img/icon_shouhui@2x.png" alt="">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="aaaa">
                  <div style="width: 100%;">
                    <div v-if="info.is_member == 0" @click="chanyughd(id, info.name,info)" class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbxzt text-center" style="font-size: calc(6px + 0.4vw);background: #FFD672;border: none;width: 55%;margin: auto;">
                      {{ $t("加入活动") }}
                    </div>
                    <div v-else class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbxzt text-center" style="font-size: calc(6px + 0.4vw);background: #E5E5E5;border: none;width: 55%;margin: auto;">
                      {{ $t("已报名") }}
                    </div>
                    <div class="pl-4 pr-4 pt-3 pb-3 yuanjiao curpo ckqbb mt-3 mb-3 sjbxzt text-center" @click="lijitianda()" v-if="info.need_questionnaire==1 && info.is_answer==0" style="font-size: calc(6px + 0.4vw);background: #FCD7D5;border: none;width: 55%;margin: auto;">
                      {{ $t("問卷調查") }}
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-3 yinc" style="align-items: center;">
                  <div>
                    <button v-if="info.is_member == 0" @click="chanyughd(id, info.name,info)" class="pl-3 pr-3 pt-2 pb-2 yuanjiao curpo mr-2 ckqbb mt-3 mb-3 sjbzt" style="font-size: calc(6px + 0.4vw);background: #FFD672;border: none;">
                      {{ $t("加入活动") }}
                    </button>
                    <button v-else class="pl-3 pr-3 pt-2 pb-2 yuanjiao curpo ckqbb mt-3 mr-2 mb-3 sjbzt" style="font-size: calc(6px + 0.4vw);background: #E5E5E5;border: none;">
                      {{ $t("已报名") }}
                    </button>
                    <button class="pl-3 pr-3 pt-2 pb-2 yuanjiao curpo ckqbb mt-3 mb-3 sjbzt" @click="lijitianda()" v-if="info.need_questionnaire==1 && info.is_answer==0" style="font-size: calc(6px + 0.4vw);background: #FCD7D5;border: none;">
                      {{ $t("問卷調查") }}
                    </button>
                  </div>
                  <div class="aaaa pl-0 pr-0">
                    <img style="width: 100px;object-fit: cover;height: 100%;" class="yuanjiao" v-if="info.image" :src="info.image" alt="" />
                    <img style="width: 100%;" v-else src="" alt="" />
                  </div>
                </div>
                <div class="col-md-4 col-lg-3 col-xl-2 tpiand pl-0 pr-0 yinc">
                  <img style="width: 100%;height: 200px;object-fit: cover;" class="yuanjiao" :src="info.image" alt="" />
                </div>
              </div>

            </div>
          </div>
          <!-- 中间部分 -->
          <div class="col-sm-12 pl-0 pr-0 items mt-3 yinc" @mouseenter="showButtons = true" @mouseleave="showButtons = false" v-if="false">
            <div class="col-sm-12 pl-0 pr-0 position-relative d-flex justify-content-between align-items-center">
              <div v-show="showButtons" class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 99999;left: 0;" @click="move(-1)">
                <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangzuo@2x.png" alt="" />
              </div>
              <div class="col-sm-12 d-flex pl-0 pr-0 d-flex" style="justify-content: flex-start;">
                <div @click="wautobutt(item.id)" class=" ckqbb  curpo yuanjiao pt-3 pb-3 position-relative mr-3" style="background: #FFFFFF;text-align: center;width: 19%;" v-for="(item, index) in visibleItems" :key="index">
                  <!-- 假设每个item是一个对象，包含图标和文字 -->
                  <img class="mb-1" style="width: calc(13px + 0.5vw);" :src="item.icon" alt="" />
                  <div class="sjbxzt" style="text-align: center;width: 100%;font-size: calc(8px + 0.4vw);">
                    {{ item.text }}
                  </div>
                  <div v-if="item.id == wauto" class="position-absolute" style="height: 2px;width: 74%;bottom: 0;background: #FFD672;left: 13%;"></div>
                </div>
              </div>
              <div v-show="showButtons" class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 99999;right: 0;" @click="move(1)">
                <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangyou@2x.png" alt="" />
              </div>
            </div>
          </div>
          <div class="items mt-3 aaaa" style="width: 100%;position: relative;" v-if="false">
            <div class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 999;left: 0;top: 34%;">
              <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangzuo@2x.png" alt="" />
            </div>
            <div class="d-flex align-items-center parent" style="width: 100%;overflow-x: auto;white-space: nowrap;">

              <div style="width: 100%;display: inline-block;background:#fff">
                <div @click="wautobutt(item.id)" class=" mr-3  yuanjiao pt-3 pb-3 sjdsdsax" v-for="(item, index) in allItems" :key="index">
                  <!-- 假设每个item是一个对象，包含图标和文字 -->
                  <img class="mb-1" style="width: calc(16px + 0.5vw);" :src="item.icon" alt="" />
                  <div class="sjbzt" style="text-align: center;width: 100%;font-size: calc(10px + 0.4vw);">
                    {{ item.text }}
                  </div>
                  <div v-show="item.id == wauto" class="position-absolute" style="height: 2px;width: 74%;bottom: 0;background: #FFD672;left: 13%;"></div>
                </div>
              </div>

            </div>
            <div class="col-auto position-absolute pl-0 pr-0 dcbd curpo xsdann" style="z-index: 999;right: 0;bottom: 34%;">
              <img style="width: calc(12px + 0.5vw);" src="@/img/details/icon_jklb_xiangyou@2x.png" alt="" />
            </div>
          </div>
          <router-view />
          <!-- 切换的下半部分  拼音 -->
          <!-- <hdzx ref="htnd" v-if="wauto == 1"></hdzx>
          <tuyaqiang ref="tuyaqiang" @tiewenshul="tiewenshul" v-if="wauto == 2"></tuyaqiang>
          <hdsj ref="hdsj" v-if="wauto == 3"></hdsj>
          <hduicy ref="hdcy" v-if="wauto == 4"></hduicy>
          <hdhk ref="hdfk" v-if='wauto == 5'></hdhk>
          <hdsjian ref="hdsjian" v-if="wauto == 6"></hdsjian> -->
        </div>

      </div>
    </div>
    <div class="col-lg-3 col-md-4 pl-0 pr-0 pl-3 yinc bbbb leftSidebarBox" ref="leftSidebarBox" style="position: fixed;right: 1.8vw;flex:1;max-width:20vw;top:9.5vh;min-height: 84.5vh;z-index:99;overflow-y: auto;" v-if="showRightMenu" >
      <div class="baise pl-0 pr-0 pt-3 pb-3 col-md-12 yuanjiao" style="min-height: 84.5vh!important;">
        <div class="mb-2 ml-3 mr-3" style="font-size: calc(6px + 0.5vw);font-weight: 500;">
          <div>{{ $t('志工') }}</div>
        </div>
        <div class="mb-2 ml-3 mr-3" style="height: 1px;background: #E5E5E5;"></div>
        <div @click="funs(item.user_id, item.user_slug)" v-for="(item, index) in volunteerList" :key="index" class="d-flex curpo justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2">
          <div class="d-flex justify-content-between align-items-center">
            <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.5vw);border-radius: 50%;" :src="item.avatar" alt="" />
            <div>
              <div class="ellipsis" style="font-size: calc(5px + 0.4vw);width: calc(105px + 1vw);">
                {{ item.username }}
              </div>
              <div class="d-flex align-items-center mt-1">
                <div class="d-flex mr-2 align-items-center" style="font-size: calc(4px + 0.4vw);color: #666666;">
                  <div>{{ item.nickname }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-2 ml-3 mr-3" style="font-size: calc(6px + 0.5vw);font-weight: 500;">
          <div>{{ $t('一般參與者') }}</div>
        </div>
        <div class="mb-2 ml-3 mr-3" style="height: 1px;background: #E5E5E5;"></div>
        <div @click="funs(item.user_id, item.user_slug)" v-for="(item, index) in participateList" :key="index" class="d-flex curpo justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2">
          <div class="d-flex justify-content-between align-items-center">
            <img class="mr-2" style="width: calc(35px + 0.5vw);height: calc(35px + 0.5vw);border-radius: 50%;" :src="item.avatar" alt="" />
            <div>
              <div class="ellipsis" style="font-size: calc(5px + 0.4vw);width: calc(105px + 1vw);">
                {{ item.username }}
              </div>
              <div class="d-flex align-items-center mt-1">
                <div class="d-flex mr-2 align-items-center" style="font-size: calc(4px + 0.4vw);color: #666666;">
                  <div>{{ item.nickname }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showImage" class="curpo" style="position: fixed;right: 5%;bottom: 10%;z-index: 999999999">
      <img @click="scrollToSection('zhixingld')" style="width: calc(36px + 0.4vw);height: calc(36px + 0.4vw);" src="@/img/icon_hssy_zhiding@2x.png" alt="">
    </div>
    <cjhdbd class="sjtop mb-3" v-show="txbiaod == 2" ref="childRef" @custom="custom" @hdfh="hdfh"></cjhdbd>

  </div>
</template>

<script>
import { EventBus } from "@/views/event-bus.js";
import { activity_detail , group_admin , activity_member } from "@/request/hshd/index.js";
import SkeletonScreen from "./SkeletonScreen/groupSkeletonScreen.vue";
// import hdzx from "@/components/hodong/hdzx.vue";
// import hduicy from "@/components/hodong/hduicy.vue";
// import hdsj from "@/components/hodong/hdsj.vue";
// import hdhk from "@/components/hodong/hdhk.vue";
// import tuyaqiang from "@/components/hodong/tuyaqiang.vue";
// import hdsjian from "@/components/hodong/hdsjian.vue";
import { formatTimestampsm } from "@/utils/common.js";
import cjhdbd from "../index/cjhdbd.vue";
import Utils from '@/utils/util.js';
export default {
  components: {
    SkeletonScreen,
    cjhdbd,
    // hduicy,
    // tuyaqiang,
    // hdzx,
    // hdsj,
    // hdhk,
    // hdsjian,
  },
  data() {
    return {
      // 获取当前屏幕的宽度设置css样式
      screenWidth: 0,
      sfoudhj: true,
      info: {},
      id: "",
      txbiaod: 1,
      wauto: 1,
      showButtons: false,
      showImage: false, // 是否显示图片
      user_list: [],
      participateList:[],
      volunteerList:[],
      showRightMenu:true,
      page: 1,
      inpsh: "",
      // 假设这是你的所有元素列表
      allItems: [
        {
          id: 2,
          icon: require("@/img/details/icon_ttxq_tuyaqiang@2x.png"),
          text: this.$t("涂鸦墙"),
        },
        {
          id: 1,
          icon: require("@/img/details/icon_ttxq_huodongzixun@2x.png"),
          text: this.$t("活动资讯"),
        },

        {
          id: 3,
          icon: require("@/img/details/icon_ttxq_huodongshujju@2x.png"),
          text: this.$t("活动数据"),
        },
        // {
        //   id: 4,
        //   icon: require("@/img/details/icon_ttxq_tuantichengyuan@2x.png"),
        //   text: this.$t("活动成员"),
        // },
        {
          id: 5,
          icon: require("@/img/details/icon_ttxq_huodongshujju@2x.png"),
          text: this.$t("活动反馈"),
        },
      ],
      // 当前显示的元素索引范围
      startIndex: 0,
      // 假设一次显示5个元素
      visibleCount: 5,
      dataLoaded: false,
      modalShow: false,

      isLoading: false,
    };
  },
  mounted() {
    this.updateScreenWidth(); // 初始化宽度
    window.addEventListener("resize", this.updateScreenWidth);
    window.addEventListener("scroll", this.handleScroll);
    
    if (this.$route.path.includes("/info")) {
      this.wauto = 1;
      this.wautobutt(1);
    } else if (this.$route.path.includes("/the_wall")) {
      this.wautobutt(2);
    } else if (this.$route.path.includes("/data-analysis")) {
      this.wautobutt(3);
    } else if (this.$route.path.includes("/members")) {
      this.wautobutt(4);
    } else if (this.$route.path.includes("/feedback")) {
      this.wautobutt(5);
    } else {
      this.wauto = 1;
      this.wautobutt(1);
    }
    var that = this;
    //监听
    Utils.$on('demo', function (obj) {
    	//监听到了
        console.log(obj);
        that.chanyughd(obj.id,obj.name,obj.info);
    })

    setTimeout(() => {
      const container = this.$refs.scrollContainer;
      console.log(container);
      // 监听容器滚动事件
      container.addEventListener("scroll", this.handleScrolls);
      this.checkSidebar();
      EventBus.$on('check-sidebar', this.checkSidebar);
    }, 1000);

    this.activity_member()
  },
  computed: {



    // 计算当前应该显示的元素列表
    visibleItems() {
      return this.allItems.slice(
        this.startIndex,
        this.startIndex + this.visibleCount
      );
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.updateScreenWidth);
    EventBus.$off("hdonmgh-call-sibling");
    EventBus.$off('check-sidebar', this.checkSidebar);
  },
  created() {
    EventBus.$on("hdonmgh-call-sibling", (msg) => {
      // 执行方法，处理接收到的数据
      // this.message = msg;
      // 如果需要，可以在这里调用其他方法
      this.id = this.$route.params.id;
      this.activity_detail();
    });
    this.id = this.$route.params.id;
    this.activity_detail();
  },
  methods: {
    checkSidebar() {
      this.$nextTick(() => {
        const exists = !!this.$refs.leftSidebarBox;
         
        EventBus.$emit('sidebar-status', exists);
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },

    async activity_member() {
      const { data, code } = await activity_member({
        id: this.id,
        page: this.page,
        account: this.inpsh,
      });
      if (code == 200) {
        console.log('data' , data.data)
        this.user_list = data.data;
        this.disposeList(data.data)
      }
    },

    disposeList(list){
      if(list && list.length){
        list.forEach((item,index)=>{
          if(item.type == 1){
            this.participateList.push(item)
          }else if(item.type == 2){
            this.volunteerList.push(item)
          }
        })
      }
    },

    formattedDescription(e){
        return e.replace(/\n/g, '<br>');
    },
    scrollToSection(sectionId) {
      this.sectionId = sectionId;
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    handleScrolls() {
      const container = this.$refs.scrollContainer;

      // 获取滚动距离
      const scrollTop = container.scrollTop;

      // 获取容器高度
      const containerHeight = container.clientHeight;

      // 判断是否滚动到 100vh
      if (scrollTop >= containerHeight) {
        this.showImage = true; // 显示图片
      } else {
        this.showImage = false; // 隐藏图片
      }
    },
    lijitianda(e) {
      this.$router.push(
        "/activity/" +
          this.$route.params.leix +
          "/" +
          this.$route.params.slug +
          "/" +
          this.info.questionnaire_number +
          "/questionnaire"
      );
    },
    // 触发分页
    handleScroll() {
      const scrollTop = window.scrollY; // 页面滚动条距离顶部的距离
      const clientHeight = window.innerHeight; // 可见区域高度
      const scrollHeight = document.documentElement.scrollHeight; // 页面内容总高度
      if (scrollTop > clientHeight) {
        this.showImage = true;
      } else {
        this.showImage = false;
      }
      if (scrollTop + clientHeight >= scrollHeight) {
        // 当滚动条距离底部小于10px时，认为是滚动到底部
        if (this.$route.path.includes("/info")) {
        } else if (this.$route.path.includes("/the_wall")) {
          EventBus.$emit("tdhdthe_wall", "tthd");
        } else if (this.$route.path.includes("/data-analysis")) {
        } else if (this.$route.path.includes("/members")) {
          EventBus.$emit("tdhdmembers", "tthd");
        } else if (this.$route.path.includes("/feedback")) {
        } else {
        }
      }
    },
    // 切换显示元素的方法
    move(direction) {
      if (direction === -1 && this.startIndex > 0) {
        this.startIndex--;
      } else if (
        direction === 1 &&
        this.startIndex + this.visibleCount < this.allItems.length
      ) {
        this.startIndex++;
      }
    },
    tiewenshul(e) {
      if (e == 1) {
        this.activity_detail();
      } else {
        this.activity_detail();
      }
    },
    async activity_detail() {
      const { data, code } = await activity_detail({
        id: this.id,
        slug: this.$route.params.slug,
      });
      if (code == 200) {
        this.dataLoaded = true;
      }
      this.info = data.info;
      setTimeout(() => {
        EventBus.$emit("chuanrusffb", this.info.is_member);
      }, 100);
    },
    hdfh(e) {
      this.txbiaod = 1;
      this.info.is_member = 1;
    },
    chanyughd(e, v, m) {
      console.log(e, v, m, "123");
      this.txbiaod = 2;
      this.showRightMenu = false
      this.checkSidebar()
      console.log(this.$refs.childRef,'啥呀')
      setTimeout(() => {
        this.$refs.childRef.msg(e, v, m);
      }, 1000);
    },
    custom() {
      this.showRightMenu = true
      this.checkSidebar()
      this.txbiaod = 1;
    },
    wautobutt(e) {
      this.wauto = e;
      if (e == 1) {
        this.$router.push({
          name: "hshdhdzx",
          params: {
            id: this.id,
            name: this.info.name,
          },
        });
      } else if (e == 3) {
        this.$router.push({
          name: "hdsj",
          params: {
            id: this.id,
            name: this.info.name,
          },
        });
        // setTimeout(() => {
        //   this.$refs.hdsj.msg(this.id, this.info.name);
        // }, 1040);
      } else if (e == 5) {
        this.$router.push({
          name: "hdhk",
          params: {
            id: this.id,
          },
        });
        // setTimeout(() => {
        //   this.$refs.hdfk.msg(this.id);
        // }, 1040);
      } else if (e == 4) {
        this.$router.push({
          name: "hdhduicy",
          params: {
            id: this.id,
            organization_id: this.info.organization_id,
          },
        });
        // setTimeout(() => {
        //   this.$refs.hdcy.msg(this.id, this.info.organization_id);
        // }, 2040);
      } else if (e == 2) {
        this.$router.push({
          name: "hdtuyaqiang",
          params: {
            id: this.id,
            is_member: this.info.is_member,
          },
        });
      }
      if (e == 6) {
        this.$router.push({
          name: "hdsjian",
          params: {
            id: this.id,
            name: this.info.name,
          },
        });
      }

      setTimeout(() => {
        this.checkSidebar()
      }, 1000);
    },
    timeFilter(stringTime) {
      return formatTimestampsm(stringTime * 1000);
    },
  },
};
</script>
<style scoped lang="scss">
@media screen and (max-width: 751px) {
}
@media screen and (max-width: 991px) {
  .heggs {
    height: 79vh !important;
  }
  .sjdsdsax {
    position: relative;
    background: #ffffff;
    text-align: center;
    width: 40% !important;
    display: inline-block;
  }
  .tpiand {
    display: none;
  }
  .sjtop {
    margin-top: 1rem !important;
  }
  .sjbgaodu {
    height: 200px !important;
    overflow: hidden !important;
  }
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjtoto {
    font-size: calc(16px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .aaaa {
    display: block !important;
  }
  .yinc {
    display: none !important;
  }

  .sjiduand1 {
    padding: 12px !important;
  }
  .bbbb {
    display: none!important;
  }
  .phoneClass{
    width: 100%!important;
    max-width: 100%!important;
  }
}
.aaaa {
  display: none;
}
.bbbb {
  display: block;
}
.phoneClass{
  width: calc(100% - 21vw);
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.dcbd:hover {
  transform: scale(1.2);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
}

.item {
  width: 30%;
  background-color: red;
}

.jhsad {
  text-align: center;
  background: #fcd7d5;
  border-radius: 12px;
  height: calc(50px + 0.4vw);
  display: flex;
  justify-content: center;
  align-items: center;
}

.parent::-webkit-scrollbar {
  display: none;
}
.imase {
  ::v-deep .img-fluid {
    height: 408px !important;
    object-fit: cover !important;
  }
}
.position-realctive{
  position: relative;
}
.banana-box{
  position: absolute;
  left: 0;
  top:0;
  z-index: 10;
  
  .event-tag{
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: 600;
  }
  .tag-volunteer{
      background-color: #FFE0B2;
      color: #E65100;
  }
  .tag-training{
    background-color: #C8E6C9;
    color: #2E7D32;
  }
  .event-meta-item{
    display: flex;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.2);
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 14px;
    color:white
  }
}
.stat-card{
    // flex: 1;
    width: 400px;
    border-radius: 12px;
    padding: 20px;
    text-align: center;
    margin: 0 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);;
}
.stat-card-small{
  width: 100%;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  // margin: 0 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);;
}
.yellow-color{
  color: #FFD672;
  border-color: #FFD672 !important;
}
.yellowBtn{
  transition: all 0.3s;
}
.yellowBtn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.overflowAuto{
  overflow: auto;
  white-space: nowrap;
}
::v-deep .progress-bar{
  background: #FFD672;
}
</style>